// @flow

export const USER_LIST_INFO_INITIATING = 'USER_LIST_INFO_INITIATING'
export const USER_LIST_INFO_INITIATED = 'USER_LIST_INFO_INITIATED'
export const USER_LIST_INFO_ERROR = 'USER_LIST_INFO_ERROR'
export const USER_LIST_INFO_CLEANUP = 'USER_LIST_INFO_CLEANUP'
